import Splide from "@splidejs/splide";
import { addPaddingOnTeaserContent, debounceEvent, detectMobileUntilTablet } from '../../../js/utils';

let context;
export default class TopBannerCarousel {
  constructor(
    topBannerSelector = '.js-top-banner-carousel',
    topBannerToggleClass = 'swa-top-banner-carousel--open',
    topBannerHideClass = 'swa-top-banner-carousel--hidden',
    topBannerCarouselSelector = '.swa-top-banner-carousel__slider',
    topBannerCloseSelector = '.js-top-banner-carousel-close',
    topBannerButtonSelector = '.top-banner-carousel__details__buttons > .swa-cms-link-component',
    topBannerDetailsSelector = '.swa-top-banner-carousel__details',
    topBannerDetailsVisibleClass = 'swa-top-banner-carousel__details-visible',
    topBannerMainSelector = '.swa-top-banner-carousel__main',
    topBannerMainButtonSelector = '.swa-top-banner-carousel__button',
    topBannerMainButtonHiddenClass = 'swa-top-banner-carousel__button--hidden',
    topBannerDetailsWrapperSelector = '.swa-top-banner-carousel__details-wrapper',
    topBannerSlidesSelector = '.swa-top-banner-carousel__slide',
    topBannerHeaderTextSelector = '.swa-top-banner-carousel__header-text'
  ) {
    this.topBannerSelector = topBannerSelector;
    this.topBannerCarouselSelector = topBannerCarouselSelector;
    this.topBannerCloseSelector = topBannerCloseSelector;
    this.topBannerToggleClass = topBannerToggleClass;
    this.topBannerButtonSelector = topBannerButtonSelector;
    this.topBannerHideClass = topBannerHideClass;
    this.topBannerDetailsSelector = topBannerDetailsSelector;
    this.topBannerDetailsVisibleClass = topBannerDetailsVisibleClass;
    this.topBannerMainButtonSelector = topBannerMainButtonSelector;
    this.topBannerMainSelector = topBannerMainSelector;
    this.topBannerMainButtonHiddenClass = topBannerMainButtonHiddenClass;
    this.topBannerDetailsWrapperSelector = topBannerDetailsWrapperSelector;
    this.topBannerSlidesSelector = topBannerSlidesSelector;
    this.topBannerHeaderTextSelector = topBannerHeaderTextSelector;
    this.topBannerElement = document.querySelector(this.topBannerSelector);
  }


  scrollObserver() {
    let observer;
    let options;

    options = {
      rootMargin: '0px 0px 100px 0px'
    };

    context = this;
    observer = new IntersectionObserver(this.handleIntersect, options);
    this.observer = observer;
    this.observer.observe(this.topBannerElement);
  }

  // top banner carousel breaks after it has 'display: none' when header sticky => refresh when it intersects
  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && context.carouselComponent) {
        context.refreshCarousel();
        context.adjustTeaserOnBannerChange();
      }
    });
  }

  init() {
    if (!this.topBannerElement) {
      return;
    }

    this.topBannerCloseButton = document.querySelector(this.topBannerCloseSelector);
    this.topBannerCarouselElement = this.topBannerElement.querySelector(this.topBannerCarouselSelector);
    this.topBannerDetailsWrapperElement = document.querySelector(this.topBannerDetailsWrapperSelector);
    this.topBannerSlidesElements = this.topBannerCarouselElement.querySelectorAll(this.topBannerSlidesSelector);
    this.slideLength = this.topBannerSlidesElements.length;

    this.header = document.querySelector('.js-swa-header');
    this.isMobile = detectMobileUntilTablet();

    // set theme variable (a theme exists only if the header is transparent & it exists a Top Teaser Component - PLP or Account)
    if (this.header.classList.contains('swa-header--transparent-light')) {
      this.theme = 'light';
    } else if (this.header.classList.contains('swa-header--transparent-dark')) {
      this.theme = 'dark';
    }

    const plpTopTeaserElement = document.querySelector('.js-swa-plp-top-teaser');
    const accountTopTeaserElement = document.querySelector('.js-account-top-teaser');

    // set Top Teaser Content element depending on which teaser is present on page (PLP or Account)
    if (plpTopTeaserElement) {
      this.topTeaserContent = plpTopTeaserElement.querySelector('.js-swa-plp-top-teaser-content');
    }
    else if (accountTopTeaserElement) {
      this.topTeaserContent = accountTopTeaserElement.querySelector('.js-account-top-teaser-content');
    }

    // move the slides on other container wrapper & limit the width of header text on mobile
    this.topBannerSlidesElements.forEach(slide => {
      if (slide) {
        const topBannerSlideDetails = slide.querySelector('.swa-top-banner-carousel__details');
        const topBannerSlideHeaderTextElement = slide.querySelector('.swa-top-banner-carousel__header-text');

        if (topBannerSlideHeaderTextElement && this.isMobile) {
          const topBannerSlideHeaderText = topBannerSlideHeaderTextElement.textContent;
          this.limitSlideHeaderText(topBannerSlideHeaderTextElement, topBannerSlideHeaderText);
        }

        if (topBannerSlideDetails) {
          this.topBannerDetailsWrapperElement.appendChild(topBannerSlideDetails);
        }
      }
    });

    this.carouselId = `#${this.topBannerCarouselElement.getAttribute('id')}`;
    this.carouselInterval = this.topBannerCarouselElement.dataset.interval;

    // if data-interval not mentioned => default should be 3.6s
    if (!this.carouselInterval) {
      this.carouselInterval = 3600;
    }

    setTimeout(() => {
      this.carouselComponent = new Splide(this.topBannerCarouselElement, {
        direction    : 'ttb',
        type         : 'loop',
        autoplay     : true,
        drag         : false,
        perPage      : 1,
        perMove      : 1,
        height       : '5.4rem',
        pauseOnFocus : false,
        pauseOnHover : true,
        arrows       : false,
        pagination   : false,
        speed        : 300,
        interval     : this.carouselInterval
      });

      this.carouselComponent.mount();
      this.scrollObserver();
    }, 0); //timeout needed in order to make sure that the carousel will be initialized only after moving the slide details on the other container


    this.topBannerCloseButton.addEventListener('click', () => {
      this.topBannerElement.classList.toggle(this.topBannerHideClass);
    });

    window.showTopBanner = () => {
      this.topBannerElement.classList.remove(this.topBannerHideClass);
    };

    this.topBannerElement.addEventListener('click', (e) => {
      this.handleBannerOnClick(e);
    });

    this.adjustHeader();
    this.addWindowResizeListener();
  }

  addWindowResizeListener() {
    window.addEventListener(
      'resize',
      debounceEvent(() => {
        let currentIsMobile = detectMobileUntilTablet();
        const sliderExtendedClass = 'swa-top-banner-carousel__slider-extended';
        const slideMainExtendedClass = 'swa-top-banner-carousel__main-extended';
        const plpTopTeaserNew = document.querySelector('.swa-plp-top-teaser--new');//new modifier class for plp top teaser wrapper, which will replace the wrapper one with the cleanup ticket
        const topBannerHeaderPosition = document.querySelector('.js-swa-top-banner-carousel-header-position');

        // if desktop
        if ((this.isMobile !== currentIsMobile) && this.isMobile) {
          // if the banner is opened => need to update the carousel options, that are different for mobile
          if (this.topBannerElement.classList.contains(this.topBannerToggleClass)) {
            this.topBannerCarouselElement.classList.remove(sliderExtendedClass);
            this.carouselComponent.options = {
              height: 54
            };
          }
          this.topBannerSlidesElements.forEach(slide => {
            if (slide) {
              const topBannerSlideHeaderTextElement = slide.querySelector('.swa-top-banner-carousel__header-text');

              if (topBannerSlideHeaderTextElement) {
                const slideHeaderTextInitial = topBannerSlideHeaderTextElement.dataset.collapsedText;

                // if banner is opened
                if (slideHeaderTextInitial) {
                  if (this.topBannerElement.classList.contains(this.topBannerToggleClass)) {
                    if (!slide.classList.contains('is-visible')) {
                      // if not active slide => we have to change its text to not be limited
                      topBannerSlideHeaderTextElement.textContent = slideHeaderTextInitial;
                    }
                  }
                  else {
                    topBannerSlideHeaderTextElement.textContent = slideHeaderTextInitial;
                  }
                }
              }
            }
          });
          // since some carousel adjustments are done => need to refresh it in order to work as expected
          this.refreshCarousel();
          this.isMobile = !this.isMobile;
          // else if mobile
        } else if ((this.isMobile !== currentIsMobile) && !this.isMobile) {
          this.topBannerSlidesElements.forEach(slide => {
            if (slide) {
              const topBannerSlideHeaderTextElement = slide.querySelector('.swa-top-banner-carousel__header-text');
              const slideMainElement = slide.querySelector(this.topBannerMainSelector);

              if (topBannerSlideHeaderTextElement) {
                const topBannerSlideHeaderText = topBannerSlideHeaderTextElement.textContent;
                // if banner is opened
                if (this.topBannerElement.classList.contains(this.topBannerToggleClass))  {
                  if (slide.classList.contains('is-visible')) {
                    // if the slide is active & text height is bigger than the carousel height => need to update the carousel options & adjust classes
                    if (topBannerSlideHeaderTextElement.offsetHeight > 54) {
                      this.carouselComponent.options = {
                        height: topBannerSlideHeaderTextElement.offsetHeight + 5
                      };
                      this.topBannerCarouselElement.classList.add(sliderExtendedClass);
                      slideMainElement.classList.add(slideMainExtendedClass);
                    }
                  }
                  // if the slide not active => need to limit the text
                  else {
                    this.limitSlideHeaderText(topBannerSlideHeaderTextElement, topBannerSlideHeaderText);
                  }
                }
                else {
                  this.limitSlideHeaderText(topBannerSlideHeaderTextElement, topBannerSlideHeaderText);
                }
              }
            }
          });
          // since some carousel adjustments are done => need to refresh it in order to work as expected
          this.refreshCarousel();
          this.isMobile = !this.isMobile;
        }

        if (plpTopTeaserNew && topBannerHeaderPosition) {
          addPaddingOnTeaserContent(this.topTeaserContent, this.topBannerElement); //  when plp new teaser with banner included inside header
        }
      }, 250)
    );
  }

  refreshCarousel () {
    this.carouselComponent.refresh();
    const { Autoplay } = this.carouselComponent.Components;

    if (this.slideLength > 1) {
      if (this.topBannerElement.classList.contains(this.topBannerToggleClass)) {
        Autoplay.pause();
      }
      else {
        Autoplay.play();
      }
    }
  }

  // limit the header text, so it can fit in the slide that has the initial height set to 54px
  limitSlideHeaderText(slideHeaderTextElement, slideHeaderText) {
    if (slideHeaderText.length > 115) {
      // the expression bellow returns the first 115 characters plus any subsequent non-space characters (to not cut words), and adds '...' at the end
      slideHeaderTextElement.textContent = slideHeaderText.replace(/^(.{115}[^\s]*).*/, "$1") + '... ';
    }
  }

  adjustHeader() {
    // if top banner is present & header has a theme => expand top overlay gradient on header & adjust padding on PLP/Account top teaser content
    if (this.theme && this.topTeaserContent) {
      const topBannerHeaderPosition = document.querySelector('.js-swa-top-banner-carousel-header-position');

      this.header.classList.add('swa-header--transparent-' + this.theme + '-with-banner');

      // if top banner inside header is removed then the header height is changed => need to update the padding & gradient overlay
      this.topBannerCloseButton.onclick = () => {
        this.header.classList.remove('swa-header--transparent-' + this.theme + '-with-banner');
        this.header.classList.remove('swa-header--transparent-' + this.theme + '-with-banner-expanded');
        if (topBannerHeaderPosition) {
          addPaddingOnTeaserContent(this.topTeaserContent, this.topBannerElement); // for plp new teaser with banner included inside header
        } else {
          addPaddingOnTeaserContent(this.topTeaserContent); // no plp new teaser or plp new teaser with banner outside header
        }
      };

      // if top banner inside header expands on click then the header height is changed => need to update the padding & gradient overlay
      this.topBannerElement.onclick = () => {
        this.adjustTeaserOnBannerChange();
      };
    }
  }

  adjustTeaserOnBannerChange() {
    setTimeout(() => {
      const header = document.querySelector('.js-swa-header');

      // if top banner is present & header has a theme => adjust top overlay on header & adjust padding on PLP/Account top teaser content
      if (this.theme && this.topTeaserContent) {
        const topBannerHeaderPosition = document.querySelector('.js-swa-top-banner-carousel-header-position');

        if (header.classList.contains('swa-header--transparent-' + this.theme + '-with-banner-expanded')) {
          header.classList.remove('swa-header--transparent-' + this.theme + '-with-banner-expanded');
        } else {
          header.classList.add('swa-header--transparent-' + this.theme + '-with-banner-expanded');
        }

        if (topBannerHeaderPosition) {
          addPaddingOnTeaserContent(this.topTeaserContent, this.topBannerElement); // for plp new teaser with banner included inside header
        } else {
          addPaddingOnTeaserContent(this.topTeaserContent); // no plp new teaser or plp new teaser with banner outside header
        }
      }
    }, 300); //top banner transition duration
  }


  handleBannerOnClick(e) {
    const { Autoplay } = this.carouselComponent.Components;
    const { MOVING } = Splide.STATES;

    // if carousel is moving when click => call function again with a delay (to avoid wrong selector of 'is-active' slide class)
    if ( this.carouselComponent.state.is(MOVING) ) {
      setTimeout(() => {
        this.handleBannerOnClick(e);
      }, 300);
      return;
    }

    const topBannerSlide = this.topBannerElement.querySelector('.swa-top-banner-carousel__slide.is-active.is-visible');
    const slideDetailsSelector = topBannerSlide.dataset.slide;
    const slideDetailsElement = this.topBannerElement.querySelector('[data-slide-content=' + slideDetailsSelector +']');
    const slideHeaderButton = topBannerSlide.querySelector(this.topBannerMainButtonSelector);
    const buttonLinkUrl = slideHeaderButton.getAttribute('href');
    const buttonLinkTarget = slideHeaderButton.getAttribute('target');

    const slideMainElement = topBannerSlide.querySelector(this.topBannerMainSelector);
    const sliderExtendedClass = 'swa-top-banner-carousel__slider-extended';
    const slideMainExtendedClass = 'swa-top-banner-carousel__main-extended';

    const slideHeaderTextElement = topBannerSlide.querySelector(this.topBannerHeaderTextSelector);
    const slideHeaderTextInitial = slideHeaderTextElement.dataset.collapsedText;
    const slideHeaderTextExpended = slideHeaderTextElement.dataset.expendedText;

    let cmsButtonSelector = `${this.topBannerButtonSelector} *`;
    let closeButtonSelector = `${this.topBannerCloseSelector}`;

    // prevent toggle/redirect when clicking on details buttons & close button
    if (!(e.target.matches(cmsButtonSelector) || e.target.matches(closeButtonSelector))) {
      // if the slide has details => toggle visibility of details/read more button & toggle autoplay
      if (slideDetailsElement) {
        slideDetailsElement.classList.toggle(this.topBannerDetailsVisibleClass);

        if (!slideDetailsElement.classList.contains(this.topBannerDetailsVisibleClass)) {
          if (this.slideLength > 1) {
            Autoplay.play();
          }

          this.topBannerElement.classList.remove(this.topBannerToggleClass);
          slideHeaderButton.style.display = 'inline-block';
          // if data-expended-text attribute is present => some updates on header text are needed
          if (slideHeaderTextExpended) {
            slideHeaderTextElement.textContent = slideHeaderTextInitial;
          }
          // when the carousel slide is closed => limit its header text & change the carousel height option & adjust classes
          if (detectMobileUntilTablet()) {
            this.limitSlideHeaderText(slideHeaderTextElement, slideHeaderTextElement.textContent);
            this.carouselComponent.options = {
              height: 54
            };
            this.topBannerCarouselElement.classList.remove(sliderExtendedClass);
            slideMainElement.classList.remove(slideMainExtendedClass);
          }

          // timeout needed for transition
          setTimeout(() => {
            slideHeaderButton.classList.remove(this.topBannerMainButtonHiddenClass);
          }, 0);
        }
        else {
          if (this.slideLength > 1) {
            Autoplay.pause();
          }

          this.topBannerElement.classList.add(this.topBannerToggleClass);
          slideHeaderButton.classList.add(this.topBannerMainButtonHiddenClass);
          // timeout needed for transition
          setTimeout(() => {
            slideHeaderButton.style.display = 'none';
            // if data-expended-text attribute is present => some updates on header text are needed, else the initial text without limitations is shown
            if (slideHeaderTextExpended) {
              slideHeaderTextElement.textContent = slideHeaderTextExpended;
            }
            else {
              slideHeaderTextElement.textContent = slideHeaderTextInitial;
            }
            // the carousel slides height is set to 54 => when opening a slide, its header text without limitations can be longer,so we need to change the carousel height option & adjust classes
            if (detectMobileUntilTablet() && slideHeaderTextElement.offsetHeight > 54) {
              this.carouselComponent.options = {
                height: slideHeaderTextElement.offsetHeight + 5
              };
              this.topBannerCarouselElement.classList.add(sliderExtendedClass);
              slideMainElement.classList.add(slideMainExtendedClass);
            }
          }, 300); //top banner transition duration
        }
      }
      // if the slide does not have details => whole banner area should be clickable and redirect to 'read more' button link
      else if (buttonLinkUrl !== '#') {
        if (buttonLinkTarget) {
          window.open(buttonLinkUrl, buttonLinkTarget).focus();
        }
        else {
          window.location.href = buttonLinkUrl;
        }
      }

      this.adjustTeaserOnBannerChange();
    }
  }
}
